import { AssignmentFilterService } from '../../../../Services/filter.service';
import { Component, Input, OnInit } from '@angular/core';
import { IServiceFactory } from 'src/app/Services/service-factory';

export interface Filter {
  name: string;
  checked: boolean;
  subFilters?: Filter[];
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  
  @Input() route;

  needsAttentionFilter: Filter;
  allComplete: boolean;
  selectedFilter: string;
  moreOptions: boolean;

  filterService: AssignmentFilterService;

  constructor(
    private serviceFactory: IServiceFactory
  ) {
    this.filterService = this.serviceFactory.getAssignmentFilterService();
   }

  ngOnInit(): void {
    
    let filterValue = this.filterService.getFilterValue()
    this.selectedFilter = filterValue.selectedFilter;
    this.moreOptions = filterValue.moreOptions;
    this.allComplete = filterValue.allComplete;
    this.needsAttentionFilter = filterValue.needsAttentionFilter;
  }

  updateAllComplete() {
    this.allComplete = this.needsAttentionFilter.subFilters != null && this.needsAttentionFilter.subFilters.every(f => f.checked);
    this.filterChanged();
  }

  someComplete(): boolean {
    if (this.needsAttentionFilter.subFilters == null) {
      return false;
    }
    return this.needsAttentionFilter.subFilters.filter(f => f.checked).length > 0 && !this.allComplete;
  }

  setAll(checked: boolean) {
    this.allComplete = checked;
    if (this.needsAttentionFilter.subFilters == null) {
      return;
    }
    this.needsAttentionFilter.subFilters.forEach(f => f.checked = checked);
    this.filterChanged();
  }

  onFilterChange = (selectedFilter) => {
    this.filterChanged();
  }

  onMoreOptions = (event) => {
    event.stopPropagation();
    if(this.selectedFilter === 'common') {
      this.moreOptions = !this.moreOptions;
    }
  }

  filterChanged = () => {
    let filterValue  = {
      selectedFilter: this.selectedFilter,
      moreOptions: this.moreOptions,
      allComplete: this.allComplete,
      needsAttentionFilter: this.needsAttentionFilter
    }
    this.filterService.setFilterValue(filterValue);
  }
}
